import Swiper from 'swiper';
import {Navigation, Pagination} from "swiper/swiper.esm";

Swiper.use([Navigation]);

const newsSlider = new Swiper('.recent-news-slider', {
    slidesPerView: 1,
    autoHeight: true,
    loop: false,
    spaceBetween: 32,
    navigation: {
        nextEl: ".news-swiper-button-next",
        prevEl: ".news-swiper-button-prev",
    },
    breakpoints: {
        700: {
            slidesPerView: 2,
        },
        1300: {
            slidesPerView: 3
        }
    },
});
